import React from 'react'
import { ShortcutKbd } from '@/components/ui/shortcut-kbd'
import { cn } from '@/utils/index'
import type { EditMenuCommands, MenuCommand } from '../types/menu-items'
import { MobileMenuSection } from './mobile-menu-section'
import { StyledMenuItem, StyledSeparator } from './styled-menu-items'

type MobileEditSectionProps = {
  commands: EditMenuCommands
  closeMenu: () => void
}

/** Edit rows dim (no `disabled` prop) when unavailable, unlike the Object section's rows. */
const DIMMED_CLASS = 'opacity-50 pointer-events-none'

export const MobileEditSection: React.FC<MobileEditSectionProps> = ({ commands, closeMenu }) => {
  const renderClosingCommand = (command: MenuCommand, index: number) => (
    <StyledMenuItem
      key={index}
      className={cn(command.disabled && DIMMED_CLASS)}
      onClick={
        command.disabled
          ? undefined
          : () => {
              command.action?.()
              closeMenu()
            }
      }
    >
      {command.label}
      {command.shortcutKey && <ShortcutKbd shortcutKey={command.shortcutKey} />}
    </StyledMenuItem>
  )

  const { selectAll, selectNone, checkSpelling } = commands

  return (
    <MobileMenuSection value="edit" label="Edit">
      {commands.history.map(renderClosingCommand)}
      <StyledSeparator />
      {commands.clipboard.map(renderClosingCommand)}
      <StyledSeparator />
      {/* Select All / Select None leave the sheet open (the desktop dropdown closes). */}
      <StyledMenuItem onClick={() => selectAll.action?.()}>
        {selectAll.label}
        <ShortcutKbd shortcutKey="selectAll" />
      </StyledMenuItem>
      <StyledMenuItem
        className={cn(selectNone.disabled && DIMMED_CLASS)}
        onClick={selectNone.disabled ? undefined : () => selectNone.action?.()}
      >
        {selectNone.label}
        <ShortcutKbd shortcutKey="selectNone" />
      </StyledMenuItem>
      <StyledSeparator />
      <StyledMenuItem
        onClick={() => {
          checkSpelling.action?.()
          closeMenu()
        }}
      >
        {checkSpelling.label}
      </StyledMenuItem>
      <StyledMenuItem>Edit Dictionary</StyledMenuItem>
    </MobileMenuSection>
  )
}
